export default __webpack_public_path__ + "static/media/Google+.9994bc17.svg";